import React, {useState} from 'react'
import {Redirect} from 'react-router-dom'
import {Modal, Radio} from 'antd'
import {fromGlobalId} from 'lib/util'
import Heading from 'components/shared/Heading'
import ReactGA from 'components/shared/GoogleAnalytics'
import OrderNavigation from 'components/shared/OrderNavigation'
import ShoppingCartLines from 'components/shared/ShoppingCartLines'
import SetInvoiceRecipient from './SetInvoiceRecipient'
import './index.scss'

const Summary = ({
  webOrder,
  bill,
  productSelection,
  productSelectionReducer,
  submitWebOrder,
  goToPreviousStep,
  isFetchingBill,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [createdOrderId, setCreatedOrderId] = useState(null)

  const changeInvoiceType = (e) => {
    productSelectionReducer({type: 'setInvoiceType', invoiceType: e.target.value})
  }

  const setInvoiceRecipient = (invoiceRecipient) => {
    const { recipientType,  organizationNumber, ...rest } = invoiceRecipient
    if (recipientType === 'business') {
      productSelectionReducer({type: 'setInvoiceRecipient', invoiceRecipient: {recipientType, organizationNumber, ...rest }})
    } else {
      productSelectionReducer({type: 'setInvoiceRecipient', invoiceRecipient: {recipientType: 'consumer', ...rest }})
    }
  }

  const onProceed = () => {
    setIsSubmitting(true)
    submitWebOrder()
      .then((order) => {
        const {sum, sumIncVat} = bill
        ReactGA.plugin.execute('ecommerce', 'addTransaction',
          {
            id: order.id,
            revenue: sumIncVat,
            tax: sumIncVat - sum,
            affiliation: webOrder.thirdPartyApplicationName,
          }
        )
        ReactGA.plugin.execute('ecommerce', 'send')
        ReactGA.plugin.execute('ecommerce', 'clear')

        setCreatedOrderId(order.id)
      })
      .catch(() => {
        setIsSubmitting(false)
        Modal.error({
          title: 'Feil ved innsending av ordre',
          content: (
            <div>
              <p>Beklager! En feil oppstod.</p>
              <p>Prøv igjen senere, eller kontakt kundeservice på 21 08 05 00.</p>
            </div>
          ),
        })
      })
  }

  if (createdOrderId) {
    return (
      <Redirect to={`/bestilling/bekreftelse/${createdOrderId}`} />
    )
  }

  const invoiceRecipient = productSelection.invoiceRecipient
  const address = webOrder.address

  return (
    <div className="new-order summary">
      <Heading level={2}>Din bestilling</Heading>

      <div className="new-order summary">
        <div className="address">
          {address.street}, {address.postalCode} {address.postalArea}
        </div>

        <ShoppingCartLines
          bill={bill}
          productSelection={productSelection}
          webOrder={webOrder}
        />

        <Heading level={3}>Fakturamottaker</Heading>
        <div className="invoice-recipient">
          {!!invoiceRecipient && (
            <>
              <div>
                {invoiceRecipient.recipientType === 'business' && (
                  <> 
                    {invoiceRecipient.organizationNumber}
                    <br />
                  </>
                )}
                {invoiceRecipient.name}
                <br />
                {invoiceRecipient.streetAddress}
                <br />
                {invoiceRecipient.postalCode} {invoiceRecipient.postalArea}
              </div>
              <div>
                {invoiceRecipient.email}
                <span className="email-notice">
                  Obs: sjekk at e-postadressen er riktig, den er viktig for faktureringen.
                </span>
              </div>
            </>
          )}

          <SetInvoiceRecipient
            invoiceRecipient={invoiceRecipient}
            onChange={setInvoiceRecipient}
            invoiceRecipientAlternatives={webOrder.invoiceRecipientAlternatives}
          />
        </div>

        {invoiceRecipient && fromGlobalId(invoiceRecipient.id).id !== 'customer' && (
          <>
            <Heading level={3}>Type faktura</Heading>
            <div className="invoice-type">
              <Radio.Group
                value={productSelection.invoiceType}
                onChange={changeInvoiceType}
              >
                <Radio value="email">E-postfaktura, kr 0</Radio>
                <Radio value="paper">Papirfaktura, gebyr kr 55 + mva.</Radio>
              </Radio.Group>
            </div>
          </>
        )}

        <OrderNavigation
          onBack={goToPreviousStep}
          onNext={onProceed}
          nextLabel="Send bestilling"
          nextButtonProps={{
            loading: isSubmitting,
            disabled: !bill || isSubmitting || isFetchingBill,
            type: 'action',
          }}
        />
      </div>
    </div>
  )
}

export default Summary
